// wrap a concatenated module body as a lazy, memoized accessor; mod is
// set before the body runs so re-entrant calls (require cycles) observe
// the partial exports like Node.js
__webpack_require__.cw = (body) => {
	var mod;
	return () => {
		if (body) {
			var fn = body;
			body = 0;
			mod = { exports: {} };
			fn.call(mod.exports, mod, mod.exports);
		}
		return mod.exports;
	};
};